// Translations for /webinar landing page (8 languages)
export const WEBINAR_I18N = {
  uk: {
    badge: 'Онлайн-вебінар',
    h1: 'Куди відправити дитину за кордон в 2026 – 2027 році на навчання?',
    subtitle: 'Все про вступ до європейських шкіл та університетів без помилок',
    date: '19.09.2026 (субота)',
    time: '12:00 (Київ)',
    format: 'Формат: онлайн',
    speaker: 'Спікер: Аліна Григорян, CEO STUDYGRI',
    speakerCaption: 'Аліна Григорян · CEO STUDYGRI',
    giftTitle: '🎁 ВАУЧЕР 100 € у подарунок',
    giftDesc: 'Кожному учаснику вебінару — ваучер на 100 € на будь-який пакет послуг STUDYGRI: вступ до університету, школа-пансіон, Foundation чи мовний курс.',
    heroCta: 'Зареєструватись безкоштовно',
    regTitle: 'Реєстрація на онлайн-вебінар',
    regDesc: 'Залиш контакти — надішлемо посилання на вебінар',
    name: 'Ім’я',
    phone: 'Телефон',
    email: 'Email',
    countryQ: 'Яка країна цікавить',
    chooseCountry: 'Оберіть країну',
    submit: 'Зареєструватись',
    sent: 'Дякуємо! Посилання на вебінар надійде на вашу пошту 🎓',
    required: 'Заповніть обов’язкові поля',
    err: 'Помилка',
    errDesc: 'Спробуйте ще раз',
    topicsTitle: '🎓 Що буде на вебінарі',
    topics: [
      { t: 'Чому варто обрати Європу', d: "Найпопулярніші країни серед українців, освіта англійською, перспективи міжнародної кар'єри" },
      { t: 'Коли починати підготовку', d: 'Етапи вступу 2026–2027, дедлайни, як не втратити навчальний рік' },
      { t: 'Як обрати країну та університет', d: "Нідерланди, Іспанія, Австрія, Німеччина, Франція — критерії вибору під бюджет сім'ї" },
      { t: 'Документи та студентська віза', d: 'Покроково: мотиваційний лист, рекомендації, подача документів, отримання візи та ВНЖ' },
      { t: 'Вартість навчання та стипендії', d: 'Де можна навчатися безкоштовно, стипендіальні програми для міжнародних студентів' },
      { t: 'Типові помилки при вступі', d: 'Що найчастіше призводить до відмови, як підвищити шанси на зарахування' }
    ],
    speakerKicker: 'Спікер вебінару',
    speakerName: 'Аліна Григорян',
    speakerRole: 'CEO & Founder STUDYGRI',
    speakerBio: 'Експерт з міжнародної освіти з 12+ роками досвіду. 1000+ студентів поступили до топ-університетів світу. Спікер конференцій ICEF у Берліні, Австралії, Римі, Севільї, Маямі, Сан-Дієго та Сан-Франциско. Відзначена у Forbes Ukraine, Forbes Kazakhstan та The Village.',
    bonusesTitle: '🎁 Бонуси для учасників',
    bonuses: [
      { t: 'Чек-лист документів для вступу' },
      { t: 'Q&A сесія зі спікером' },
      { t: 'Персональні рекомендації щодо вибору країни та університету' },
      { t: 'Спеціальна пропозиція для учасників', d: 'Сплатіть 300€ та отримайте знижку 300€ на пакет супроводу від STUDYGRI' }
    ],
    finalTitle: 'Реєструйся зараз — місця обмежені',
    finalSub: '15.08.2026 о 12:00 за київським часом · Онлайн',
    countries: ['🇺🇸 США','🇬🇧 Велика Британія','🇳🇱 Нідерланди','🇨🇭 Швейцарія','🇮🇪 Ірландія','🇩🇪 Німеччина','🇫🇷 Франція','🇦🇹 Австрія','🇪🇸 Іспанія','🇵🇱 Польща','🇨🇿 Чехія','🇦🇺 Австралія','🇨🇦 Канада','Інша']
  },
  ru: {
    badge: 'Онлайн-вебинар',
    h1: 'Куда отправить ребёнка за границу в 2026 – 2027 году на обучение?',
    subtitle: 'Всё о поступлении в европейские школы и университеты без ошибок',
    date: '19.09.2026 (суббота)',
    time: '12:00 (Киев)',
    format: 'Формат: онлайн',
    speaker: 'Спикер: Алина Григорян, CEO STUDYGRI',
    speakerCaption: 'Алина Григорян · CEO STUDYGRI',
    giftTitle: '🎁 ВАУЧЕР 100 € в подарок',
    giftDesc: 'Каждому участнику вебинара — ваучер на 100 € на любой пакет услуг STUDYGRI: поступление в университет, школа-пансион, Foundation или языковой курс.',
    heroCta: 'Зарегистрироваться бесплатно',
    regTitle: 'Регистрация на онлайн-вебинар',
    regDesc: 'Оставь контакты — пришлём ссылку на вебинар',
    name: 'Имя',
    phone: 'Телефон',
    email: 'Email',
    countryQ: 'Какая страна интересует',
    chooseCountry: 'Выберите страну',
    submit: 'Зарегистрироваться',
    sent: 'Спасибо! Ссылка на вебинар придёт на вашу почту 🎓',
    required: 'Заполните обязательные поля',
    err: 'Ошибка',
    errDesc: 'Попробуйте ещё раз',
    topicsTitle: '🎓 Что будет на вебинаре',
    topics: [
      { t: 'Почему стоит выбрать Европу', d: 'Самые популярные страны, образование на английском, перспективы международной карьеры' },
      { t: 'Когда начинать подготовку', d: 'Этапы поступления 2026–2027, дедлайны, как не потерять учебный год' },
      { t: 'Как выбрать страну и университет', d: 'Нидерланды, Испания, Австрия, Германия, Франция — критерии выбора под бюджет семьи' },
      { t: 'Документы и студенческая виза', d: 'Пошагово: мотивационное письмо, рекомендации, подача документов, получение визы и ВНЖ' },
      { t: 'Стоимость обучения и стипендии', d: 'Где можно учиться бесплатно, стипендиальные программы для иностранных студентов' },
      { t: 'Типичные ошибки при поступлении', d: 'Что чаще всего приводит к отказу, как повысить шансы на зачисление' }
    ],
    speakerKicker: 'Спикер вебинара',
    speakerName: 'Алина Григорян',
    speakerRole: 'CEO & Founder STUDYGRI',
    speakerBio: 'Эксперт по международному образованию с 12+ лет опыта. 1000+ студентов поступили в топ-университеты мира. Спикер конференций ICEF в Берлине, Австралии, Риме, Севилье, Майами, Сан-Диего и Сан-Франциско. Отмечена в Forbes Ukraine, Forbes Kazakhstan и The Village.',
    bonusesTitle: '🎁 Бонусы для участников',
    bonuses: [
      { t: 'Чек-лист документов для поступления' },
      { t: 'Q&A сессия со спикером' },
      { t: 'Персональные рекомендации по выбору страны и университета' },
      { t: 'Специальное предложение для участников', d: 'Оплатите 300€ и получите скидку 300€ на пакет сопровождения от STUDYGRI' }
    ],
    finalTitle: 'Регистрируйся сейчас — мест ограничено',
    finalSub: '15.08.2026 в 12:00 по киевскому времени · Онлайн',
    countries: ['🇺🇸 США','🇬🇧 Великобритания','🇳🇱 Нидерланды','🇨🇭 Швейцария','🇮🇪 Ирландия','🇩🇪 Германия','🇫🇷 Франция','🇦🇹 Австрия','🇪🇸 Испания','🇵🇱 Польша','🇨🇿 Чехия','🇦🇺 Австралия','🇨🇦 Канада','Другая']
  },
  en: {
    badge: 'Online webinar',
    h1: 'Studying in Europe 2026–2027 🇪🇺',
    subtitle: 'Everything about enrolling at European universities — without mistakes',
    date: '19.09.2026 (Saturday)',
    time: '12:00 (Kyiv time)',
    format: 'Format: online',
    speaker: 'Speaker: Alina Grigoryan, CEO STUDYGRI',
    speakerCaption: 'Alina Grigoryan · CEO STUDYGRI',
    giftTitle: '🎁 €100 VOUCHER as a gift',
    giftDesc: 'Every webinar attendee receives a €100 voucher towards any STUDYGRI service package: university admission, boarding school, Foundation or language course.',
    heroCta: 'Register for free',
    regTitle: 'Register for the online webinar',
    regDesc: 'Leave your contacts — we’ll send you the webinar link',
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    countryQ: 'Country of interest',
    chooseCountry: 'Choose a country',
    submit: 'Register',
    sent: 'Thank you! The webinar link will arrive at your inbox 🎓',
    required: 'Please fill in the required fields',
    err: 'Error',
    errDesc: 'Please try again',
    topicsTitle: '🎓 What we’ll cover',
    topics: [
      { t: 'Why choose Europe', d: 'Most popular destinations, English-taught programs, international career outlook' },
      { t: 'When to start preparing', d: 'Admission stages 2026–2027, deadlines, how not to lose an academic year' },
      { t: 'How to pick a country and university', d: 'Netherlands, Spain, Austria, Germany, France — selection criteria by family budget' },
      { t: 'Documents and student visa', d: 'Step by step: motivation letter, recommendations, submission, visa and residence permit' },
      { t: 'Tuition costs and scholarships', d: 'Where you can study for free, scholarship programs for international students' },
      { t: 'Typical admission mistakes', d: 'What most often leads to rejection and how to boost your chances' }
    ],
    speakerKicker: 'Webinar speaker',
    speakerName: 'Alina Grigoryan',
    speakerRole: 'CEO & Founder STUDYGRI',
    speakerBio: 'International education expert with 12+ years of experience. 1000+ students enrolled at top universities worldwide. Speaker at ICEF conferences in Berlin, Australia, Rome, Seville, Miami, San Diego and San Francisco. Featured in Forbes Ukraine, Forbes Kazakhstan and The Village.',
    bonusesTitle: '🎁 Bonuses for attendees',
    bonuses: [
      { t: 'Admission documents checklist' },
      { t: 'Live Q&A with the speaker' },
      { t: 'Personal recommendations on country & university choice' },
      { t: 'Special offer for attendees', d: 'Pay €300 and get €300 off the STUDYGRI support package' }
    ],
    finalTitle: 'Register now — seats are limited',
    finalSub: '04.07.2026 at 12:00 Kyiv time · Online',
    countries: ['🇺🇸 USA','🇬🇧 United Kingdom','🇳🇱 Netherlands','🇨🇭 Switzerland','🇮🇪 Ireland','🇩🇪 Germany','🇫🇷 France','🇦🇹 Austria','🇪🇸 Spain','🇵🇱 Poland','🇨🇿 Czechia','🇦🇺 Australia','🇨🇦 Canada','Other']
  },
  pl: {
    badge: 'Webinar online',
    h1: 'Studia w Europie 2026–2027 🇪🇺',
    subtitle: 'Wszystko o rekrutacji na europejskie uczelnie — bez błędów',
    date: '19.09.2026 (sobota)',
    time: '12:00 (czas kijowski)',
    format: 'Format: online',
    speaker: 'Prelegent: Alina Grigoryan, CEO STUDYGRI',
    speakerCaption: 'Alina Grigoryan · CEO STUDYGRI',
    giftTitle: '🎁 VOUCHER 100 € w prezencie',
    giftDesc: 'Każdy uczestnik webinaru otrzyma voucher 100 € na dowolny pakiet usług STUDYGRI: rekrutację na uczelnię, szkołę z internatem, Foundation lub kurs językowy.',
    heroCta: 'Zarejestruj się bezpłatnie',
    regTitle: 'Rejestracja na webinar online',
    regDesc: 'Zostaw kontakt — wyślemy link do webinaru',
    name: 'Imię',
    phone: 'Telefon',
    email: 'Email',
    countryQ: 'Interesujący kraj',
    chooseCountry: 'Wybierz kraj',
    submit: 'Zarejestruj się',
    sent: 'Dziękujemy! Link do webinaru otrzymasz na e-mail 🎓',
    required: 'Wypełnij wymagane pola',
    err: 'Błąd',
    errDesc: 'Spróbuj ponownie',
    topicsTitle: '🎓 Co będzie na webinarze',
    topics: [
      { t: 'Dlaczego warto wybrać Europę', d: 'Najpopularniejsze kierunki, studia po angielsku, perspektywy międzynarodowej kariery' },
      { t: 'Kiedy zacząć przygotowania', d: 'Etapy rekrutacji 2026–2027, terminy, jak nie stracić roku akademickiego' },
      { t: 'Jak wybrać kraj i uczelnię', d: 'Holandia, Hiszpania, Austria, Niemcy, Francja — kryteria pod budżet rodziny' },
      { t: 'Dokumenty i wiza studencka', d: 'Krok po kroku: list motywacyjny, rekomendacje, składanie dokumentów, wiza i karta pobytu' },
      { t: 'Koszty studiów i stypendia', d: 'Gdzie można studiować bezpłatnie, programy stypendialne dla zagranicznych studentów' },
      { t: 'Typowe błędy w rekrutacji', d: 'Co najczęściej prowadzi do odmowy i jak zwiększyć szanse' }
    ],
    speakerKicker: 'Prelegent webinaru',
    speakerName: 'Alina Grigoryan',
    speakerRole: 'CEO & Founder STUDYGRI',
    speakerBio: 'Ekspert edukacji międzynarodowej z 12+ letnim doświadczeniem. 1000+ studentów dostało się na topowe uczelnie świata. Prelegent konferencji ICEF w Berlinie, Australii, Rzymie, Sewilli, Miami, San Diego i San Francisco. Wymieniana w Forbes Ukraine, Forbes Kazakhstan i The Village.',
    bonusesTitle: '🎁 Bonusy dla uczestników',
    bonuses: [
      { t: 'Lista dokumentów rekrutacyjnych' },
      { t: 'Sesja Q&A z prelegentem' },
      { t: 'Indywidualne rekomendacje wyboru kraju i uczelni' },
      { t: 'Specjalna oferta dla uczestników', d: 'Wpłać 300€ i otrzymaj 300€ rabatu na pakiet wsparcia STUDYGRI' }
    ],
    finalTitle: 'Zarejestruj się teraz — liczba miejsc ograniczona',
    finalSub: '04.07.2026 o 12:00 czasu kijowskiego · Online',
    countries: ['🇺🇸 USA','🇬🇧 Wielka Brytania','🇳🇱 Holandia','🇨🇭 Szwajcaria','🇮🇪 Irlandia','🇩🇪 Niemcy','🇫🇷 Francja','🇦🇹 Austria','🇪🇸 Hiszpania','🇵🇱 Polska','🇨🇿 Czechy','🇦🇺 Australia','🇨🇦 Kanada','Inny']
  },
  it: {
    badge: 'Webinar online',
    h1: 'Studiare in Europa 2026–2027 🇪🇺',
    subtitle: 'Tutto sull’ammissione alle università europee — senza errori',
    date: '19.09.2026 (sabato)',
    time: '12:00 (ora di Kyiv)',
    format: 'Formato: online',
    speaker: 'Relatrice: Alina Grigoryan, CEO STUDYGRI',
    speakerCaption: 'Alina Grigoryan · CEO STUDYGRI',
    giftTitle: '🎁 VOUCHER 100 € in regalo',
    giftDesc: 'Ogni partecipante al webinar riceve un voucher da 100 € su qualsiasi pacchetto di servizi STUDYGRI: ammissione universitaria, collegio, Foundation o corso di lingua.',
    heroCta: 'Registrati gratis',
    regTitle: 'Registrazione al webinar online',
    regDesc: 'Lascia i tuoi contatti — ti invieremo il link al webinar',
    name: 'Nome',
    phone: 'Telefono',
    email: 'Email',
    countryQ: 'Paese di interesse',
    chooseCountry: 'Scegli un paese',
    submit: 'Registrati',
    sent: 'Grazie! Il link al webinar arriverà nella tua casella 🎓',
    required: 'Compila i campi obbligatori',
    err: 'Errore',
    errDesc: 'Riprova',
    topicsTitle: '🎓 Cosa vedremo al webinar',
    topics: [
      { t: 'Perché scegliere l’Europa', d: 'Le destinazioni più richieste, programmi in inglese, carriera internazionale' },
      { t: 'Quando iniziare la preparazione', d: 'Fasi di ammissione 2026–2027, scadenze, come non perdere un anno' },
      { t: 'Come scegliere paese e università', d: 'Paesi Bassi, Spagna, Austria, Germania, Francia — criteri in base al budget familiare' },
      { t: 'Documenti e visto studente', d: 'Passo dopo passo: lettera motivazionale, raccomandazioni, invio, visto e permesso di soggiorno' },
      { t: 'Tasse e borse di studio', d: 'Dove studiare gratis, programmi di borsa per studenti internazionali' },
      { t: 'Errori tipici nell’ammissione', d: 'Cosa porta più spesso al rifiuto e come migliorare le possibilità' }
    ],
    speakerKicker: 'Relatrice del webinar',
    speakerName: 'Alina Grigoryan',
    speakerRole: 'CEO & Founder STUDYGRI',
    speakerBio: 'Esperta di educazione internazionale con oltre 12 anni di esperienza. 1000+ studenti ammessi nelle migliori università del mondo. Relatrice alle conferenze ICEF di Berlino, Australia, Roma, Siviglia, Miami, San Diego e San Francisco. Citata in Forbes Ukraine, Forbes Kazakhstan e The Village.',
    bonusesTitle: '🎁 Bonus per i partecipanti',
    bonuses: [
      { t: 'Checklist dei documenti di ammissione' },
      { t: 'Sessione Q&A con la relatrice' },
      { t: 'Consigli personalizzati su paese e università' },
      { t: 'Offerta speciale per i partecipanti', d: 'Paga 300€ e ricevi 300€ di sconto sul pacchetto STUDYGRI' }
    ],
    finalTitle: 'Registrati ora — posti limitati',
    finalSub: '04.07.2026 alle 12:00 ora di Kyiv · Online',
    countries: ['🇺🇸 USA','🇬🇧 Regno Unito','🇳🇱 Paesi Bassi','🇨🇭 Svizzera','🇮🇪 Irlanda','🇩🇪 Germania','🇫🇷 Francia','🇦🇹 Austria','🇪🇸 Spagna','🇵🇱 Polonia','🇨🇿 Cechia','🇦🇺 Australia','🇨🇦 Canada','Altro']
  },
  es: {
    badge: 'Webinar online',
    h1: 'Estudiar en Europa 2026–2027 🇪🇺',
    subtitle: 'Todo sobre la admisión en universidades europeas — sin errores',
    date: '19.09.2026 (sábado)',
    time: '12:00 (hora de Kyiv)',
    format: 'Formato: online',
    speaker: 'Ponente: Alina Grigoryan, CEO STUDYGRI',
    speakerCaption: 'Alina Grigoryan · CEO STUDYGRI',
    giftTitle: '🎁 BONO 100 € de regalo',
    giftDesc: 'Cada participante del webinar recibe un bono de 100 € para cualquier paquete de servicios STUDYGRI: admisión universitaria, internado, Foundation o curso de idiomas.',
    heroCta: 'Regístrate gratis',
    regTitle: 'Registro al webinar online',
    regDesc: 'Deja tus datos — te enviaremos el enlace al webinar',
    name: 'Nombre',
    phone: 'Teléfono',
    email: 'Email',
    countryQ: 'País de interés',
    chooseCountry: 'Elige un país',
    submit: 'Registrarme',
    sent: '¡Gracias! El enlace al webinar llegará a tu correo 🎓',
    required: 'Completa los campos obligatorios',
    err: 'Error',
    errDesc: 'Inténtalo de nuevo',
    topicsTitle: '🎓 Qué veremos en el webinar',
    topics: [
      { t: 'Por qué elegir Europa', d: 'Destinos más populares, programas en inglés, perspectivas de carrera internacional' },
      { t: 'Cuándo empezar a prepararse', d: 'Etapas de admisión 2026–2027, plazos, cómo no perder un año académico' },
      { t: 'Cómo elegir país y universidad', d: 'Países Bajos, España, Austria, Alemania, Francia — criterios según el presupuesto familiar' },
      { t: 'Documentos y visa de estudiante', d: 'Paso a paso: carta de motivación, recomendaciones, envío, visa y residencia' },
      { t: 'Costes y becas', d: 'Dónde estudiar gratis, programas de becas para estudiantes internacionales' },
      { t: 'Errores típicos al postular', d: 'Qué suele provocar el rechazo y cómo aumentar tus posibilidades' }
    ],
    speakerKicker: 'Ponente del webinar',
    speakerName: 'Alina Grigoryan',
    speakerRole: 'CEO & Founder STUDYGRI',
    speakerBio: 'Experta en educación internacional con más de 12 años de experiencia. 1000+ estudiantes admitidos en las mejores universidades del mundo. Ponente en conferencias ICEF en Berlín, Australia, Roma, Sevilla, Miami, San Diego y San Francisco. Mencionada en Forbes Ukraine, Forbes Kazakhstan y The Village.',
    bonusesTitle: '🎁 Bonos para los participantes',
    bonuses: [
      { t: 'Checklist de documentos de admisión' },
      { t: 'Sesión Q&A con la ponente' },
      { t: 'Recomendaciones personalizadas de país y universidad' },
      { t: 'Oferta especial para los participantes', d: 'Paga 300€ y recibe 300€ de descuento en el paquete de STUDYGRI' }
    ],
    finalTitle: 'Regístrate ahora — plazas limitadas',
    finalSub: '04.07.2026 a las 12:00 hora de Kyiv · Online',
    countries: ['🇺🇸 EE.UU.','🇬🇧 Reino Unido','🇳🇱 Países Bajos','🇨🇭 Suiza','🇮🇪 Irlanda','🇩🇪 Alemania','🇫🇷 Francia','🇦🇹 Austria','🇪🇸 España','🇵🇱 Polonia','🇨🇿 Chequia','🇦🇺 Australia','🇨🇦 Canadá','Otro']
  },
  zh: {
    badge: '线上网络研讨会',
    h1: '2026–2027 欧洲留学 🇪🇺',
    subtitle: '欧洲大学申请的全方位指南——避免常见错误',
    date: '2026.09.19（周六）',
    time: '12:00（基辅时间）',
    format: '形式：线上',
    speaker: '主讲人：Alina Grigoryan，STUDYGRI 创始人兼 CEO',
    speakerCaption: 'Alina Grigoryan · STUDYGRI CEO',
    giftTitle: '🎁 100 € 礼券',
    giftDesc: '每位网络研讨会参与者均可获得 100 € 礼券，可用于任意 STUDYGRI 服务套餐：大学申请、寄宿学校、Foundation 或语言课程。',
    heroCta: '免费注册',
    regTitle: '线上研讨会注册',
    regDesc: '留下联系方式 — 我们会发送研讨会链接',
    name: '姓名',
    phone: '电话',
    email: '邮箱',
    countryQ: '感兴趣的国家',
    chooseCountry: '请选择国家',
    submit: '注册',
    sent: '感谢！研讨会链接将发送至您的邮箱 🎓',
    required: '请填写必填项',
    err: '错误',
    errDesc: '请重试',
    topicsTitle: '🎓 研讨会内容',
    topics: [
      { t: '为什么选择欧洲', d: '热门国家、英文授课、国际职业前景' },
      { t: '什么时候开始准备', d: '2026–2027 申请阶段、截止日期、如何避免错过学年' },
      { t: '如何选择国家与大学', d: '荷兰、西班牙、奥地利、德国、法国——按家庭预算选择' },
      { t: '材料与学生签证', d: '动机信、推荐信、申请提交、签证与居留' },
      { t: '学费与奖学金', d: '哪里可以免费学习，国际学生奖学金项目' },
      { t: '常见申请错误', d: '导致被拒的常见原因以及如何提高录取率' }
    ],
    speakerKicker: '研讨会主讲人',
    speakerName: 'Alina Grigoryan',
    speakerRole: 'STUDYGRI 创始人兼 CEO',
    speakerBio: '国际教育专家，12 年以上经验。1000+ 学生进入世界顶尖大学。曾在柏林、澳大利亚、罗马、塞维利亚、迈阿密、圣地亚哥、旧金山的 ICEF 大会上发言。获 Forbes Ukraine、Forbes Kazakhstan、The Village 报道。',
    bonusesTitle: '🎁 参与者福利',
    bonuses: [
      { t: '申请材料清单' },
      { t: '与主讲人进行 Q&A' },
      { t: '国家与大学选择的个性化建议' },
      { t: '参会专属优惠', d: '支付 300€ 即可获得 300€ STUDYGRI 服务包减免' }
    ],
    finalTitle: '立即注册 — 名额有限',
    finalSub: '2026.07.04 基辅时间 12:00 · 线上',
    countries: ['🇺🇸 美国','🇬🇧 英国','🇳🇱 荷兰','🇨🇭 瑞士','🇮🇪 爱尔兰','🇩🇪 德国','🇫🇷 法国','🇦🇹 奥地利','🇪🇸 西班牙','🇵🇱 波兰','🇨🇿 捷克','🇦🇺 澳大利亚','🇨🇦 加拿大','其他']
  },
  ar: {
    badge: 'ندوة عبر الإنترنت',
    h1: 'الدراسة في أوروبا 2026–2027 🇪🇺',
    subtitle: 'كل ما تحتاج معرفته للقبول في الجامعات الأوروبية — دون أخطاء',
    date: '19.09.2026 (السبت)',
    time: '19:00 (بتوقيت كييف)',
    format: 'الصيغة: عبر الإنترنت',
    speaker: 'المتحدّثة: ألينا غريغوريان، الرئيسة التنفيذية لـ STUDYGRI',
    speakerCaption: 'ألينا غريغوريان · المديرة التنفيذية STUDYGRI',
    giftTitle: '🎁 قسيمة 100 € هديّة',
    giftDesc: 'كل مشارك في الندوة يحصل على قسيمة بقيمة 100 € على أي باقة خدمات STUDYGRI: القبول الجامعي، المدارس الداخلية، Foundation أو دورات اللغة.',
    heroCta: 'سجّل مجاناً',
    regTitle: 'التسجيل في الندوة الإلكترونية',
    regDesc: 'اترك بياناتك — سنرسل لك رابط الندوة',
    name: 'الاسم',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    countryQ: 'الدولة التي تهمّك',
    chooseCountry: 'اختر دولة',
    submit: 'سجّل الآن',
    sent: 'شكراً لك! سيصلك رابط الندوة إلى بريدك 🎓',
    required: 'يرجى تعبئة الحقول المطلوبة',
    err: 'خطأ',
    errDesc: 'حاول مرة أخرى',
    topicsTitle: '🎓 ماذا سنتناول في الندوة',
    topics: [
      { t: 'لماذا تختار أوروبا', d: 'أكثر الوجهات شعبيّة، برامج باللغة الإنجليزية، مستقبل مهني دولي' },
      { t: 'متى تبدأ التحضير', d: 'مراحل القبول 2026–2027، المواعيد النهائية، كيف لا تضيّع سنة دراسية' },
      { t: 'كيف تختار الدولة والجامعة', d: 'هولندا، إسبانيا، النمسا، ألمانيا، فرنسا — معايير حسب ميزانية العائلة' },
      { t: 'الوثائق وتأشيرة الطالب', d: 'خطوة بخطوة: خطاب الدوافع، التوصيات، تقديم الوثائق، التأشيرة والإقامة' },
      { t: 'الرسوم والمنح', d: 'أين يمكنك الدراسة مجاناً، برامج المنح للطلاب الدوليين' },
      { t: 'الأخطاء الشائعة في التقديم', d: 'ما يؤدّي غالباً إلى الرفض وكيف تزيد فرص قبولك' }
    ],
    speakerKicker: 'المتحدّثة في الندوة',
    speakerName: 'ألينا غريغوريان',
    speakerRole: 'مؤسِّسة ورئيسة STUDYGRI',
    speakerBio: 'خبيرة تعليم دولي بخبرة تتجاوز 12 عاماً. ساعدت أكثر من 1000 طالب في الالتحاق بأفضل الجامعات حول العالم. متحدّثة في مؤتمرات ICEF في برلين، أستراليا، روما، إشبيلية، ميامي، سان دييغو، سان فرانسيسكو. ذُكرت في Forbes Ukraine وForbes Kazakhstan وThe Village.',
    bonusesTitle: '🎁 مكافآت للمشاركين',
    bonuses: [
      { t: 'قائمة وثائق التقديم' },
      { t: 'جلسة أسئلة وأجوبة مع المتحدّثة' },
      { t: 'توصيات شخصية حول اختيار الدولة والجامعة' },
      { t: 'عرض خاص للمشاركين', d: 'ادفع 300€ واحصل على خصم 300€ على باقة STUDYGRI' }
    ],
    finalTitle: 'سجّل الآن — المقاعد محدودة',
    finalSub: '04.07.2026 الساعة 12:00 بتوقيت كييف · عبر الإنترنت',
    countries: ['🇺🇸 الولايات المتحدة','🇬🇧 المملكة المتحدة','🇳🇱 هولندا','🇨🇭 سويسرا','🇮🇪 أيرلندا','🇩🇪 ألمانيا','🇫🇷 فرنسا','🇦🇹 النمسا','🇪🇸 إسبانيا','🇵🇱 بولندا','🇨🇿 التشيك','🇦🇺 أستراليا','🇨🇦 كندا','أخرى']
  }
};

export const getWebinarT = (lang) => WEBINAR_I18N[lang] || WEBINAR_I18N.uk;
